var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "all_form_block", attrs: { "data-name": "job-stack" } },
    [
      _c("div", { staticClass: "block" }, [
        _c("div", { staticClass: "name_tools", attrs: { id: "job-stack" } }, [
          _vm._v(_vm._s(_vm.$store.getters.cv_t("job_stack")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "all_form" }, [
          _c("div", { staticClass: "inp_info" }, [
            _c(
              "ul",
              [
                _vm._l(_vm.jobStacks, function(jobStack) {
                  return _vm._l(jobStack.translations, function(translation) {
                    return _c(
                      "li",
                      {
                        key: translation.id,
                        staticClass: "job-stack",
                        on: {
                          click: function($event) {
                            return _vm.selectJobStack(
                              jobStack.id,
                              translation.title,
                              $event
                            )
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(translation.title))])]
                    )
                  })
                })
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.$store.state.cv.jobStack.id
        ? _c("div", { staticClass: "edit_block_form inp_info" }, [
            _c("div", { staticClass: "tab_menu" }, [
              _c(
                "ul",
                _vm._l(_vm.currencies, function(currency) {
                  return _c("li", [
                    _c(
                      "span",
                      {
                        staticClass: "center_currency",
                        class: {
                          active:
                            _vm.$store.state.cv.jobStackCurrency.id ===
                            currency.id
                        },
                        on: {
                          click: function($event) {
                            return _vm.selectCurrency(currency)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(currency.symbol) +
                            "\n              "
                        )
                      ]
                    )
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "div_relative" }, [
              _c("div", {
                staticClass: "close",
                on: {
                  click: function($event) {
                    return _vm.reset()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "roller" },
                [
                  _c("div", { staticClass: "name_number w90" }, [
                    _c("div", { staticClass: "name_roller" }, [
                      _c("p", [
                        _vm._v(
                          "\n                     " +
                            _vm._s(_vm.$store.state.cv.jobStack.title) +
                            "\n                     "
                        ),
                        _c("strong", [
                          _vm._v(
                            "/" + _vm._s(_vm.$store.getters.cv_t("monthly"))
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "number_roller" },
                      [
                        _vm.$store.state.cv.jobStack.sallery
                          ? [
                              _vm._v(
                                "\n                     " +
                                  _vm._s(
                                    _vm.$parent.$parent.XFormatPrice(
                                      _vm.$store.state.cv.jobStack.sallery
                                    )
                                  ) +
                                  "\n                     "
                              ),
                              _vm.plus()
                                ? _c("strong", [_vm._v("+")])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.state.cv.jobStackCurrency.symbol
                                  )
                                )
                              ])
                            ]
                          : [
                              _vm._v(
                                "\n                     " +
                                  _vm._s(
                                    _vm.$store.getters.cv_t("contractual")
                                  ) +
                                  "\n                  "
                              )
                            ]
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$store.state.cv.jobStack.id,
                        expression: "$store.state.cv.jobStack.id"
                      }
                    ],
                    attrs: { type: "hidden", name: "job_stack" },
                    domProps: { value: _vm.$store.state.cv.jobStack.id },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.$store.state.cv.jobStack,
                          "id",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("vue-slider", {
                    attrs: {
                      min: 0,
                      max: _vm.$store.state.cv.jobStackCurrency.max,
                      interval: _vm.$store.state.cv.jobStackCurrency.step
                    },
                    model: {
                      value: _vm.$store.state.cv.jobStack.sallery,
                      callback: function($$v) {
                        _vm.$set(_vm.$store.state.cv.jobStack, "sallery", $$v)
                      },
                      expression: "$store.state.cv.jobStack.sallery"
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a1fbbac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1fbbac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/tools-components/JobStack.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4a1fbbac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/tools-components/JobStack.vue
// module chunks = 0